<div class="review-container">
  <div class="empty-state" *ngIf="!hasReviews()">

    <div><img src="assets/review-empty-state.svg"></div>
    <div class="empty-state-title">
      <p i18n="@@emptyRateTitle">No ratings yet</p>
    </div>
    <div class="empty-state-message">
      <p i18n="@@emptyTabsMessage">Be the first to share your experience!</p>
    </div>
    <div class="empty-review-button" *ngIf="true">
      <primary-button [title]="reviewLabel" (onClick)="writeReview()"></primary-button>
    </div>
  </div>
  <div class="merchant-review-container"
       *ngIf="this.ratingApiResponse !== null && this.ratingApiResponse.data.isNotEmpty()">
    <div class="overall-title">
      <p i18n="@@overallRating">Overall Rating</p>
    </div>
    <div class="merchant-overall-rating-content">
      <div>
        <img src="assets/star-icon.svg">
      </div>
      <div class="overall-rate-container">
        <div class="overall-rate">
          <p>{{ getAverageRating() }}</p>
        </div>
        <div class="number-of-reviews">
          <p>Based on {{ numberOfReviews }} reviews</p>
        </div>
      </div>
      <div class="write-review-button" *ngIf="true">
        <primary-button title="Leave a Review" (onClick)="writeReview()"></primary-button>
      </div>
    </div>
    <div class="customer-review-item-container" *ngFor="let rating of ratingApiResponse?.data">
      <div class="customer-review-details">
        <div class="customer-image">
          <img [src]="getImageAvatar(rating)">
        </div>
        <div class="customer-review-info">
          <div class="customer-name">
            <p>{{ rating.commenter.name }}</p>
          </div>
          <div class="customer-review-date">
            <p>{{ rating.createdAt | date : 'dd MMM yyyy' }}</p>
          </div>
        </div>
        <div class="customer-rate">
          <img [src]="rating.rating >= 1 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
          <img [src]="rating.rating >= 2 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
          <img [src]="rating.rating >= 3 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
          <img [src]="rating.rating >= 4 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
          <img [src]="rating.rating >= 5 ? 'assets/star-icon.svg' : 'assets/in-active-star-icon.svg'">
        </div>
      </div>
      <div class="customer-review-content">
        <p>{{ rating.comment }}</p>
      </div>

      <div class="d-flex" *ngIf="showRemoveBtn(rating)">
        <div class="remove-btn clickable" (click)="onRemoveRate(rating)">
          <span *ngIf="!isRemoveRateLoading" i18n="@@Remove">Remove</span>
          <div *ngIf="isRemoveRateLoading" class="spinner-container">
            <div class="spinner-border text-white" role="status">
            </div>
          </div>
          </div>
      </div>

    </div>
  </div>
</div>

<login-alert> </login-alert>
